import { ThemeOptions } from '@mui/material';

export const themeButton: ThemeOptions['components'] = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableFocusRipple: true,
    },
    styleOverrides: {
      root: ({ ownerState, theme }) => {
        const { color, variant } = ownerState;
        let borderColor = 'inherit';
        let bgColor = 'inherit';
        let txColor = 'inherit';
        if (color === undefined) {
          borderColor = theme.palette.primary.main;
          bgColor = theme.palette.primary.light;
          txColor = theme.palette.primary.dark;
        }
        if (color !== undefined && color !== 'inherit') {
          borderColor = theme.palette[color].main;
          bgColor = theme.palette[color].light;
          txColor = theme.palette[color].dark;
        }

        return {
          // Button共通
          borderRadius: '8px',
          padding: '8px 14px',
          '&:focus': {
            borderWidth: '2px',
            borderStyle: 'solid',
            borderColor: theme.palette.action.buttonFocus,
          },
          // variant=contained
          ...(variant === 'contained' && {
            border: '2px solid transparent',
          }),
          // variant=outlined
          ...(variant === 'outlined' && {
            borderWidth: 2,
            borderColor,
            '&:disabled': {
              borderWidth: 2,
            },
            '&:hover': {
              borderWidth: 2,
              backgroundColor: bgColor,
            },
          }),
          // variant=text
          ...(variant === 'text' && {
            fontSize: '0.875rem',
            fontWeight: 400,
            textDecorationLine: 'underline',
            border: '2px solid transparent',
            '&:hover': {
              color: txColor,
              textDecorationLine: 'underline',
            },
          }),
        };
      },
      sizeMedium: {
        minWidth: 122,
        fontSize: 12,
      },
      sizeSmall: {
        minWidth: 100,
        fontSize: 12,
      },
    },
  },
};
